import { render, staticRenderFns } from "./AppUserDropdown.vue?vue&type=template&id=fb8c6cf4&scoped=true"
import script from "./AppUserDropdown.vue?vue&type=script&lang=ts"
export * from "./AppUserDropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb8c6cf4",
  null
  
)

export default component.exports